import { _bugReport_ } from "../features/auth/authSlice";

export const sendBugReport = async (
  organization,
  user,
  errorMessage,
  action,
  dispatch
) => {
  try {
    const bugReport = {
      org_id: organization._id["$oid"],
      user_id: user._id["$oid"],
      organization_state: JSON.stringify(organization),
      user_state: JSON.stringify(user),
      error_message: errorMessage,
      actionCausedThisBug: action,
      timestamp: new Date().toISOString(),
    };

    const response = await dispatch(_bugReport_(bugReport));

    return response.payload;
  } catch (error) {
    console.error("Failed to send bug report:", error);
  }
};
